import * as type from './action-types';

export const initialState = {
  socialSecurityNr: '',
  email: '',
  inProgress: false,
  createOnAuth: false,
  authType: 'MOBILE',
  error: null
};

export default function bankId (state = initialState, action) {
  switch (action.type) {
    case type.SET_SOCIAL_SECURITY_NR:
      return Object.assign({}, state, {
        socialSecurityNr: action.payload
      });

    case type.SET_EMAIL:
      return Object.assign({}, state, {
        email: action.payload
      });

    case type.SET_IN_PROGRESS:
      return Object.assign({}, state, {
        inProgress: action.payload
      });

    case type.SET_LOGIN_SUCCEEDED:
      return Object.assign({}, state, {
        success: action.payload
      });

    case type.SET_ERROR:
      return Object.assign({}, state, {
        error: action.payload
      });

    case type.SET_AUTH_TYPE:
      return Object.assign({}, state, {
        authType: action.payload
      });

    case type.SET_ENTITY:
      return Object.assign({}, state, {
        entity: action.payload
      });

    case type.SET_CREATE_ON_AUTH:
      return Object.assign({}, state, {
        createOnAuth: action.payload
      });

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/bank-id/reducer.js
 **/